
import bitkubConfig from "./config/bitkubConfig";
import yesCoinConfig from "./config/yesCoinConfig.js";

export default {
    config: function (mainApp) {
        var config = null;
        switch (mainApp) {
            case 'bitkub':
                config = bitkubConfig.config();
                break;
            case 'yescoin':
                config = yesCoinConfig.config();
                break;
        }
        return config;
    },
}
